 <ion-content class="invoice"  *ngIf="invoiceDetails as inv">
     <app-header [isParentPage]="false" [title]="'Invoice'"></app-header>
         <div class="invoice-wrapper" style="padding-top:100px">
             <div class="loading-container" style="padding-top:15%" *ngIf="!loaded">
                <ion-spinner></ion-spinner>
             </div>

    <table class="header-table">
      <tr>
        <td class="logo">
           <img src="./assets/images/gallagher logo_h.png" alt="Gallagher Image" />
        </td>
        <td class="invoice-meta" style="float:right">
         <table class="invoice-header">
            <tr>
                <td class="label">INVOICE #:</td>
                <td class="label">{{ inv.invoiceCode }}</td>
            </tr>
            <tr>
                <td class="label">Date:</td>
                <td class="value">{{ inv.dateOfInvoice | date:'MM/dd/yyyy' }}</td>
            </tr>
            <tr>
                <td class="label">Customer #:</td>
                <td class="value">{{ inv.customer?.name }}</td>
            </tr>
            <tr>
                <td class="label">Stop #:</td>
                <td class="value">{{ inv.stopCode }}</td>
            </tr>
            <tr>
                <td class="label">Purchase Order #:</td>
                <td class="value">{{ inv.ponum }}</td>
            </tr>
            <tr>
                <td class="label">
                     <button
                    class="code hidden-for-print header-size print-link"
                    (click)="changePrinterView()">
                    Print
                </button>
                </td>
                <td class="value">
               
                </td>
            </tr>
            </table>

        </td>
      </tr>
    </table>

   <hr style="border:0.5px solid black; margin:0; height:0;"/>

    <table class="address-table">
      <tr>
        <td>
          <b>Invoice To:</b><br />
          {{ inv.address?.billingName }}<br />
          {{ inv.address?.billingAddress1 }}<br />
          {{ inv.address?.billingCity }},
          {{ inv.address?.billingState }}
          {{ inv.address?.billingPostalCode }}
        </td>

        <td>
          <b>Deliver To:</b><br />
          {{ inv.address?.deliveryName }}<br />
          {{ inv.address?.deliveryAddress1 }}<br />
          {{ inv.address?.deliveryCity }},
          {{ inv.address?.deliveryState }}
          {{ inv.address?.deliveryPostalCode }}
        </td>
      </tr>
    </table>

    <table class="route-table">
      <tr class="green">
        <th>Route Service Representative</th>
        <th>Week</th>
        <th>Day</th>
        <th>Route</th>
        <th>Route Service Supervisor</th>
      </tr>
      <tr>
        <td>{{ inv.routeRep }}</td>
        <td>{{ inv.routeWeek }}</td>
        <td>{{ inv.routeDay }}</td>
        <td>{{ inv.routeCode }}</td>
        <td >{{ inv.routeSup }}</td>
      </tr>
    </table>

   <table class="invoice-table" style=" border-collapse: separate; border-spacing: 0;border-left: 1px solid black;border-right: 1px solid black;">
  <colgroup>
    <col style="width:5%">   
    <col style="width:7%">  
    <col style="width:7%">   
    <col style="width:15%"> 
    <col style="width:25%"> 
    <col style="width:6%">   
    <col style="width:8%">  
    <col style="width:8%">   
    <col style="width:9%">  
    <col style="width:10%">  
  </colgroup>

  <tr class="green">
    <th>Line</th>
    <th>Wash Qty</th>
    <th>Garment Label ID</th>
    <th>Item or Employee Name</th>
    <th>Product</th>
    <th>Size</th>
    <th>Inven Qty</th>
    <th>Charge Qty</th>
    <th>Unit Price</th>
    <th>Invoice Amount</th>
  </tr>

  <tr *ngFor="let item of inv.invoiceItems; let i = index">
    <td>{{ i + 1 }}</td>
    <td>{{ item.washQty }}</td>
    <td>{{ item.employeeCode }}</td>
    <td>{{ item.itemName }}</td>
    <td>{{ item.itemCode }}</td>
    <td>{{ item.size1 }}</td>
    <td>{{ item.issueQty }}</td>
    <td>{{ item.chargeQty }}</td>
    <td>{{ item.chargeAmt | currency:'USD' }}</td>
    <td>{{ item.billingAmount | currency:'USD' }}</td>
  </tr>
</table>


<table class="totals-section" style="width:100%; border-collapse: collapse; margin-top:0;">
  <tr class="desktop-view">
    <td style="width:70%; text-align:center; padding:10px; border-right:1px solid black; border-bottom:none;">
      <strong>Thank you for letting us serve you!</strong>
    </td>

    <td style="width:30%; text-align:left; vertical-align: top; border-bottom:none;">
      <table style="width:100%; border-collapse: collapse;" class="size-change">
        <tr style="border-bottom:1px solid black;">
          <td style="width:50%; border-right:1px solid black; padding:4px;">Sub total</td>
          <td style="width:50%; padding:4px;">{{ subTotal | currency:'USD' }}</td>
        </tr>
        <tr>
          <td style="border-right:1px solid black; padding:4px;">State Tax</td>
          <td style="padding:4px;">{{ invoiceDetails.tax1Amount | currency:'USD' }}</td>
        </tr>
      </table>
    </td>
  </tr>

  <tr class="mobile-view">
    <td colspan="2" style="text-align:center; padding:10px;">
      <strong>Thank you for letting us serve you!</strong>
    </td>
  </tr>

  <tr class="mobile-view ">
    <td colspan="2" style="text-align:left; padding:0;">
      <table style="width:100%; border-collapse: collapse;" class="size-change">
        <tr style="border-bottom:1px solid black;">
          <td style="width:50%; border-right:1px solid black; padding:4px;">Sub total</td>
          <td style="width:50%; padding:4px;">{{ subTotal | currency:'USD' }}</td>
        </tr>
        <tr>
          <td style="border-right:1px solid black; padding:4px;">State Tax</td>
          <td style="padding:4px;">{{ invoiceDetails.tax1Amount | currency:'USD' }}</td>
        </tr>
      </table>
    </td>
  </tr>
</table>
<table class="signature-section" style="width:100%; margin-top:0px; border-collapse: collapse; ">
  <tr>
    <td style="width:50%; border:1px solid black; padding:6px;background-color:#ccffcc;">Customer Signature</td>
    <td style="width:16.6%; border:1px solid black; padding:6px;background-color:#ccffcc;">Terms</td>
    <td style="width:16.6%; border:1px solid black; padding:6px;background-color:#ccffcc;">Due Date</td>
    <td style="width:16.6%; border:1px solid black; padding:6px;background-color:#ccffcc;">Invoice Total</td>
  </tr>
  <tr>
    <td style="border:1px solid black; padding:6px;"></td>
    <td style="border:1px solid black; padding:6px;">{{invoiceDetails.termName}}</td>
    <td style="border:1px solid black; padding:6px;">{{invoiceDetails.dueDate | date:'MM/dd/yyyy'}}</td>
    <td style="border:1px solid black; padding:6px;">{{invoiceDetails.amountDue | currency:'USD'}}</td>
  </tr>
</table>
  </div>
 <app-footer></app-footer>
</ion-content>
